module.exports = __webpack_public_path__ + "img/img-3-9mobile.39f7c71f.webp";